export default class FeatureComponent {
    constructor () {
      new Vue({
        el: '#features-component',
        data() {
          return {
            isExpand : false,
          }
        },
        methods: {
          openFeatures() {
            const el = document.querySelectorAll('.drp-content');

            if (!el) {
              return;
            }

            this.isExpand = !this.isExpand;

            this.isExpand ? $(el).addClass('!flex') : $(el).removeClass('!flex');

          },
          openFeature(id) {
            const el = document.getElementById(`hidden_${id}`);

            if (!el) {
              return;
            }

            $(el).toggleClass('!flex');
          }
        },
      })
    }
}

$(document).on("ready", () => (window.FeatureComponent = new FeatureComponent()));



// WEBPACK FOOTER //
// ./resources/js/FeatureComponent.js